import { ActionsUnion, createAction } from "../../../store/definitions";
import { HosDisplayPreferencesActionTypes } from "./types";

export interface ISetSplitSleeperEnabledPayload {
    userId: string;
    enabled: boolean;
}

export const HosDisplayPreferencesActions = {
    setSplitSleeperEnabled: (payload: ISetSplitSleeperEnabledPayload) =>
        createAction(HosDisplayPreferencesActionTypes.SET_SPLIT_SLEEPER_ENABLED, payload),
    clearSplitSleeperPreference: (userId: string) =>
        createAction(HosDisplayPreferencesActionTypes.CLEAR_SPLIT_SLEEPER_PREFERENCE, userId)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type HosDisplayPreferencesActions = ActionsUnion<typeof HosDisplayPreferencesActions>;
